import { InjectionToken } from '@angular/core';
import { ProxyLoginOptions } from '@cuepid/admin/core/models/proxy-login-options';

export const PROXY_LOGIN_OPTIONS = new InjectionToken<ProxyLoginOptions>(
  'PROXY_LOGIN_OPTIONS'
);
